<template>
  <div>
    <span class="form__row-label">{{fieldsData.label}} <span v-if="fieldsData.required">*</span></span>

    <div
      class="signature-container"
      ref="container"
    >
      <vue-drawing-canvas
        class="signature"
        :ref="refName"
        :canvas-id="refName"
        height="100"
        :width="width"
        line-cap = 'round'
        line-join = 'round'
        :class="{'disabled': isDisabledField, 'is-invalid': isInvalid}"
        :disabled="isDisabledField"
        :background-image="backgroundImage"
      />

      <button
        v-if="!isDisabledField"
        class="btn btn--color-outline-inactive signature-clear-btn"
        @click="clear()"
      >X</button>
    </div>
  </div>
  
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas'
export default {
  components: {
    VueDrawingCanvas,
  },
  props: {
    fieldsData: {
      type: Object,
      default: () => {},
    },
    isDisabledField: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String,
      required: true
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    width: 450,
    backgroundImage: null,
  }),
  mounted() {
    if (this.fieldsData.value) {
      this.fromDataURL(this.fieldsData.value)
    }

    const container = this.$refs.container
    if (container) {
      const onDrawStart = () => {
        this.$emit('clear-invalid')
      }

      container.addEventListener('mousedown', onDrawStart)
      container.addEventListener('touchstart', onDrawStart)
    }
  },
  methods:{
    clear(){
      this.backgroundImage = null
      this.$refs[this.refName].reset()
    },
    fromDataURL(url){
      this.backgroundImage = url
    },
    isEmptySignature() {
      return this.$refs[this.refName]?.isEmpty() && !this.loadedImage
    },
    saveSignature() {
      const canvas = this.$refs[this.refName]
      if (canvas && !canvas.isEmpty()) {
        return canvas.save()
      }
      return null
    }
  }
}
</script>

